<div class="modal fade logistics-bulk-modal logistics-crm-modal" [id]="modalId" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><span [innerHTML]="getCRMIcon(crmName | lowercase)"></span> Export to {{formattedCRMName || 'CRM'}}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body max-height-85vh">
        <p class="logistics-modal-intro" *ngIf="openedSelection">{{ selectionCount(openedSelection) | number }} selected companies. Review matching records, then choose which to update or create.</p>
        @if (exporterLoading()) {
        <zint-loader size="small" overlay="true"></zint-loader>
        }
        <details open>
          <summary>
            <h5 class="mb-0 d-inline-block">Existing records found in {{formattedCRMName}}</h5>            
          </summary>
          @if (crmService.wizardLoading().isLoadingWizardStepAction) {
            <zint-loader size="xxSmall"></zint-loader>
          }
          @else if (pubMethods.hasData(foundMatchedList)) {
          
            <button class="rounded-btn-base rounded-btn-light btn-p-md mb-2"
              [disabled]="crmService.wizardLoading().isLoadingExporter" matTooltipPosition="above"
              matTooltip="&#9888; Uses your export quota" (click)="updateHubspotRecords()">Update {{formattedCRMName}} Records For
              Selected
            </button>
          
          <div class="zint-rounded-table-container">
            <table class="table zint-rounded-table">
              <thead>
                <tr>
                  <th scope="col">
                    <input type="checkbox" name="selectAllCRMExistingRecords" [(ngModel)]="allExistingChecked"
                      (change)="toggleAllCheckboxes('existing')" />
                  </th>
                  <th scope="col">Matched Company Number</th>
                  <th scope="col">Matching Record Name ({{formattedCRMName}})</th>
                  <th scope="col" class="text-center">View Record in {{formattedCRMName}}</th>
                </tr>
              </thead>
              <tbody>
                @for (matchObj of foundMatchedList; track $index) {
                <tr>
                  <td>
                    <input type="checkbox" name="selectExistingCRMRecordToUpdate" [(ngModel)]="matchObj.checked" />
                  </td>
                  <td>{{matchObj.ukCompanyNumber}}</td>
                  <td>{{matchObj.ukCompanyName}}</td>
                  <td class="text-center">
                    <a href="{{matchObj.crmUrl}}" target="_blank" class="rounded-btn-base rounded-btn-orange btn-p-sm" [matTooltip]="'Record ID: '+matchObj.crmRecordId" matTooltipPosition="right">
                      <span [innerHTML]="getCRMIcon(crmName | lowercase)"></span>
                    </a>
                    <i class="fal fa-external-link fa-xs ml-1"></i>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>          
          }@else {
          <p *ngIf="!crmService.wizardLoading().isLoadingExporter" class="bg-light text-center">No existing records were found in {{formattedCRMName}}.</p>
          }
        </details>

        <hr class="my-4">
        
        <details open>
          <summary>
            <h5 class="mb-0 d-inline-block">Records not found in {{formattedCRMName}}</h5>
          </summary>
          @if (crmService.wizardLoading().isLoadingWizardStepAction) {
          <zint-loader size="xxSmall"></zint-loader>
          }
          @else if (pubMethods.hasData(noMatchingList)) {
          <div class="zint-rounded-table-container">
            <button class="rounded-btn-base rounded-btn-light btn-p-md mb-2"
              [disabled]="crmService.wizardLoading().isLoadingExporter || isCreatingRecords" matTooltipPosition="above"
              matTooltip="&#9888; Uses your export quota" (click)="createHubspotRecords()">Create New {{formattedCRMName}} Records
              For Selected
            </button>
            <table class="table zint-rounded-table">
              <thead>
                <tr>
                  <th scope="col">
                    <input type="checkbox" name="selectAllNewRecords" [(ngModel)]="allNewChecked"
                      (change)="toggleAllCheckboxes('new')" />
                  </th>
                  <th scope="col">Company Name (Zint)</th>
                  <th scope="col">Company Number (Zint)</th>
                </tr>
              </thead>
              <tbody>
                @for (noMatchObj of noMatchingList; track $index) {
                <tr>
                  <td>                     
                    @if (!noMatchObj.hasBeenCreated) {                
                      <input type="checkbox" name="selectCRMRecordToUpdate" [(ngModel)]="noMatchObj.checked" />                  
                    }
                  </td>                  
                  <td>{{noMatchObj.ukCompanyName}}</td>
                  <td>{{noMatchObj.ukCompanyNumber}}</td>
                  
                  @if (noMatchObj.createdURL) {
                    <td class="border-bottom">
                    <a href="{{noMatchObj.createdURL}}" target="_blank" class="rounded-btn-base rounded-btn-orange btn-p-sm" matTooltip="View in {{formattedCRMName}}" matTooltipPosition="right">
                      <span [innerHTML]="getCRMIcon(crmName | lowercase)"></span>
                    </a>
                    <i class="fal fa-external-link fa-xs ml-1"></i>
                  </td>
                  }
                </tr>                
                }
              </tbody>
            </table>
          </div>          
          }@else {
          <p *ngIf="!crmService.wizardLoading().isLoadingExporter" class="bg-light text-center">All the selected records were found in {{formattedCRMName}}.</p>
          }
        </details>                    
      
      </div>
    </div>
  </div>
</div>
